import React from 'react'
import { useIsSmartviewMounted } from '@morningtrain/react-smartviews'
import * as Animations from 'ui/animations'

export default function SmartviewOverlay () {
  const isSmartviewMounted = useIsSmartviewMounted()

  return (
    <Animations.FadeIn in={isSmartviewMounted} duration={300} animationContainer={false}>
      <div style={{ backgroundColor: 'rgba(0,0,0,.35)' }} className='overlay w-full h-full fixed top-0 right-0 z-10' />
    </Animations.FadeIn>
  )
}
